import React, { Component } from 'react';
import propTypes from 'prop-types';
import Hammer from 'hammerjs';

import FontAwesome from 'react-fontawesome';
import { SKINS } from '~/Config/Products';
import { PORTRAIT_IMAGE } from '~/Redux/Modules/Admin/Skins';

import Product from '~/Components/Global/Stripe/Product';
import Button from '~/Components/Global/Form/Button';
import { findImagePath } from '~/Context/Global';
import { TABLET_WIDTH } from '~/Redux/Constants';
import mParticle, { ScreenViewEvent } from '~/Providers/mParticle';

import './SkinSelect.scss';

const env = process.env.NODE_ENV || 'local';

class SkinSelect extends Component {
  constructor() {
    super();
    this.state = {
      next: false,
      current: false,
      previous: false,
      fetched: false,
    };
  }

  componentDidMount = () => {
    mParticle.logEvent(new ScreenViewEvent('Choose Cover'));
    this.props.getSkins();
    if (this.selector) {
      this.hammer = new Hammer(this.selector);
      this.hammer.on('swipeleft', () => this.decrement());
      this.hammer.on('swiperight', () => this.increment());
    }
  };

  componentWillUnmount = () => {
    if (this.selector && this.hammer) {
      this.hammer.off('swipeleft');
      this.hammer.off('swiperight');
    }
  };

  componentWillReceiveProps = nextProps => {
    // Check UserOptions have been fetched and Skins are Loaded
    if (nextProps.fetched && !this.state.fetched && nextProps.skins && nextProps.skins.length) {
      // If Current User has a default skin Selected
      if (nextProps.userOptions.skin && nextProps.userOptions.skin.id) {
        // Find Current selected skin
        nextProps.skins.map((skin, index) => {
          if (skin.id === nextProps.userOptions.skin.id) {
            this.setState({
              // Set user selected skin as current (Middle Skin)
              current: index,
            });
            // if there is another skin AFTER current we will set it to next otherwise will leave as false (Right side)
            if (nextProps.skins[index + 1]) {
              this.setState({
                next: index + 1,
              });
            }
            // if there is another skin BEFORE current we will set it to previous otherwise will leave as false (Left side)
            if (nextProps.skins[index - 1]) {
              this.setState({
                previous: index - 1,
              });
            }
          }
        });
      } else {
        // If no skin is set for current user Set current and next only
        this.setState({
          current: 0,
        });
        if (nextProps.skins.length >= 1) {
          this.setState({
            next: 1,
          });
        }
      }
      // Set set to fetched to avoid infinite loops
      this.setState({
        fetched: true,
      });
    }
  };

  decrement = () => {
    // check that we have a previous (left side) item to move to current
    if (this.props.skins[this.state.previous]) {
      this.setState({
        // set current to previous (middle)
        current: this.state.previous,
        // set next to current (right side)
        next: this.state.current,
      });
      // if there is a another item one less than previous
      if (this.props.skins[this.state.previous - 1]) {
        this.setState({
          // Set it to be the new previous (left side)
          previous: this.state.previous - 1,
        });
      } else {
        // if there is no more items then set previous to be false so it will not display
        this.setState({
          previous: false,
        });
      }
    }
  };

  increment = () => {
    // check that we have a next (right side) item to move to current
    if (this.props.skins[this.state.next]) {
      this.setState({
        // set current to next (middle)
        current: this.state.next,
        // set previous to current (right side)
        previous: this.state.current,
      });
      // if there is a another item one more than next
      if (this.props.skins[this.state.next + 1]) {
        this.setState({
          // Set it to be the new next (right side)
          next: this.state.next + 1,
        });
      } else {
        // if there is no more items then set next to be false so it will not display
        this.setState({
          next: false,
        });
      }
    }
  };

  render() {
    const { isFetching, updateSkin, userOptions, skins } = this.props;
    const { next, current, previous } = this.state;
    return (
      <div className="skin-select" ref={c => (this.selector = c)}>
        <div className="next-skin">
          {skins[next] && (
            <div
              className={`next-image ${
                (env == 'production' && skins[next].id <= 92) ||
                (env == 'beta' && skins[next].id <= 92) ||
                (env == 'staging' && skins[next].id <= 67)
                  ? 'cover'
                  : ''
              }`}
              style={{
                background: `url(${findImagePath(
                  skins[next].images,
                  PORTRAIT_IMAGE,
                  window.innerWidth <= TABLET_WIDTH
                )})`,
              }}
            />
          )}
        </div>
        <button onClick={this.increment} className="decrement-button circle left">
          <FontAwesome name="angle-left" />
        </button>
        <div className="current-skin">
          {skins[current] && [
            <Product
              key="a"
              product={skins[current].product}
              description={skins[current].name}
              type={SKINS}
            />,
            skins[current].product.purchased &&
              (skins[current].id === userOptions.skin_id ? (
                <Button
                  key="b"
                  text="Default"
                  disabled
                  className="margin-bottom btn btn-default pill center"
                />
              ) : (
                <Button
                  key="b"
                  type="submit"
                  text="Set as Default"
                  actionText="Setting"
                  isFetching={isFetching}
                  disabled={isFetching}
                  className="margin-bottom btn btn-default pill center"
                  onClick={() => updateSkin(userOptions.id, skins[current].id, skins[current])}
                />
              )),
            <div key="c" className="mobile-spacer" />,
            <div
              key="d"
              className={`current-image ${
                (env == 'production' && skins[current].id <= 92) ||
                (env == 'beta' && skins[current].id <= 92) ||
                (env == 'staging' && skins[current].id <= 67)
                  ? 'cover'
                  : ''
              }`}
              style={{
                background: `url(${findImagePath(
                  skins[current].images,
                  PORTRAIT_IMAGE,
                  window.innerWidth <= TABLET_WIDTH
                )})`,
              }}
            />,
          ]}
        </div>
        <button onClick={this.decrement} className="increment-button circle right">
          <FontAwesome name="angle-right" />
        </button>
        <div className="previous-skin">
          {skins[previous] && (
            <div
              className={`previous-image ${
                (env == 'production' && skins[previous].id <= 92) ||
                (env == 'beta' && skins[previous].id <= 92) ||
                (env == 'staging' && skins[previous].id <= 67)
                  ? 'cover'
                  : ''
              }`}
              style={{
                background: `url(${findImagePath(
                  skins[previous].images,
                  PORTRAIT_IMAGE,
                  window.innerWidth <= TABLET_WIDTH
                )})`,
              }}
            />
          )}
        </div>
      </div>
    );
  }
}

SkinSelect.propTypes = {
  userOptions: propTypes.object,
  updateSkin: propTypes.func,
  getSkins: propTypes.func,
  isFetching: propTypes.bool,
  fetched: propTypes.bool,
  skins: propTypes.array,
};

export default SkinSelect;
